import { IconBulb, IconFlame, IconHeart, IconThumbUp, IconTrophy, type TablerIcon } from "@tabler/icons-react"
import { type FC } from "react"

import { type CommunityPostReactionType } from "@forento/core/models/community"

import { cn } from "../utilities/tailwind"

const icons: Record<CommunityPostReactionType, TablerIcon> = {
	like: IconThumbUp,
	love: IconHeart,
	insightful: IconBulb,
	motivated: IconFlame,
	wellDone: IconTrophy,
}

const colors: Record<CommunityPostReactionType, string> = {
	like: "text-blue-600",
	love: "text-rose-500",
	insightful: "text-amber-500",
	motivated: "text-orange-500",
	wellDone: "text-emerald-600",
}

type Props = {
	type: CommunityPostReactionType
	size?: number
	className?: string
}

const CommunityPostReactionIcon: FC<Props> = ({ type, size = 20, className }) => {
	const Icon = icons[type]
	return <Icon size={size} stroke={2} className={cn("shrink-0", colors[type], className)} aria-hidden="true" />
}

export default CommunityPostReactionIcon
